module.exports = __webpack_public_path__ + "static/media/140.4f4947e8.jpg";